module.exports = __webpack_public_path__ + "bcb11ae378352d2cfae255b85bd8d1a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/menu/images/small-plates-hero.jpg
// module id = x8a/
// module chunks = 0